import axios from 'axios'

const search = async (city, business, search) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/evento/search`, { city, business, search })
  return data
}

const getMetaTags = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento/metatag/${id}`)
  return data
}

const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento/${id}`)
  return data
}

export {
  search,
  get,
  getMetaTags
}
